<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <!-- <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                            <div class="alert" :class="'alert-' + flashType">{{ flashMessage }}</div>
                        </div> -->
          </div>
          <div id="details">
            <div class="col-sm-12 text-right">
              <!-- <button class="btn btn-danger mr-5" type="button" @click="updateTripGroupDetails"
                                v-permission.if="[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD]">Update Trip
                                Group Details</button> -->
              <!-- <button class="btn btn-danger mr-5" type="button" @click="updateTripGroupHalts"
                                v-permission.if="[USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN, USER_ROLES.GA_HEAD]">Update Trip
                                Group Halt</button> -->
              <button class="btn btn-danger mr-5" type="button" @click="deleteTripModal" v-permission.if="[
                USER_ROLES.ADMIN,
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.GA_HEAD,
              ]">
                Delete Trip
              </button>
            </div>
            <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.region)">
                    <label>Geographical Area</label>
                    <vue-select label="value" :options="this.region_list" :searchable="true" language="en-US"
                      v-model="trip.region" @input="selectGA">
                    </vue-select>
                  </validate>

                  <field-messages name="region" show="$touched || $submitted" class="form-control-feedback">
                    <div slot="required">
                      Geographical Area is a required field
                    </div>
                  </field-messages>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.vehicleId)">
                    <label>Vehicle</label>
                    <vue-select label="value" :options="this.vehicle_no" :searchable="true" language="en-US"
                      v-model="trip.vehicleId" @input="getDeviceName">
                    </vue-select>
                    <field-messages name="vehicleId" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">Vehicle is a required field</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-6">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.deviceId)">
                    <label>Device</label>
                    <select v-model="trip.deviceId" disabled required name="deviceId" class="form-control">
                      <option disabled>Device</option>
                      <option v-for="(item, index) in device_name" :key="index" :value="item.key">
                        {{ item.value }}
                      </option>
                    </select>
                    <field-messages name="deviceId" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">device is a required field</div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-4">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.driverId)">
                    <label class="control-label">
                      Drivers
                    </label>
                    <vue-select label="value" multiple :options="this.driver_name" :searchable="true"
                      @input="driverStatus" language="en-US" v-model="trip.driverId">
                    </vue-select>
                  </validate>
                </div>
                <!-- <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.driverId)">
                                        <label>Driver</label>
                                        <select required v-model="trip.driverId" name="driverId" class="form-control">
                                            <option disabled>Driver</option>
                                            <option v-for="(item, index) in driver_name" :key="index" :value="item.key">
                                                {{ item.value }}
                                            </option>
                                        </select>
                                        <field-messages name="driverId" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Driver is a required field</div>
                                        </field-messages>

                                    </validate>
                                </div> -->
                <div class="col-sm-4">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduleDate)">
                    <label>Scheduled Date</label>
                    <date-picker id="scheduleDate" required v-model="trip.scheduleDate" :not-before="disabledBefore"
                      disabled lang="en" name="scheduleDate" input-class="form-control" width="100%" use-utc="true"
                      format="DD-MM-YYYY"></date-picker>
                    <field-messages name="scheduleDate" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">
                        Schedule Date is a required field
                      </div>
                      <div slot="pattern">Schedule Date is invalid</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-2">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduleTime)">
                    <label>Scheduled Time</label>
                    <vue-timepicker name="scheduleTime" disabled required v-model="trip.scheduleTime"
                      style="width: 271px"></vue-timepicker>
                    <field-messages name="scheduleTime" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">
                        Schedule Time is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <!-- <div class="col-sm-6">
                                    <validate auto-label class="form-group required-field"
                                        :class="fieldClassName(formstate.routeId)">
                                        <label>Route Name</label>
                                        <select v-model="trip.routeId" required name="routeId" class="form-control"
                                            @change="getSites">
                                            <option disabled>Select Route</option>
                                            <option v-for="(item, index) in route_name" :key="index" v-bind:value="item._id"
                                                v-bind:sourceSite="item.startSite" v-bind:destinationSite="item.endSite">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                        <field-messages name="routeId" show="$touched || $submitted"
                                            class="form-control-feedback">
                                            <div slot="required">Route is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div> -->

                <div class="col-sm-3">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.regionManager)">
                    <label>HCV Operation Manager</label>
                    <!-- <select v-model="trip.regionManager" required name="regionManager"
                                            class="form-control">
                                            <option disabled>Select HCV Operation Manager</option>
                                            <option v-for="(item, index) in region_managers" :key="index" :value="item.key">
                                                {{ item.value }}
                                            </option>
                                        </select> -->

                    <vue-select label="value" :options="this.region_managers" :searchable="true"
                      @input="HCVOperationStatus" language="en-US" v-model="trip.regionManager">
                    </vue-select>
                    <field-messages name="regionManager" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">
                        HCV Operation Manager is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-3">
                  <validate auto-label class="form-group required-field"
                    :class="fieldClassName(formstate.journeyManager)">
                    <label>Journey Manager</label>
                    <!-- <select v-model="trip.journeyManager" required name="journeyManager"
                                            class="form-control">
                                            <option selected disabled>Select Journey Manager</option>
                                            <option v-for="(item, index) in journey_managers" :key="index"
                                                :value="item.key">
                                                {{ item.value }}
                                            </option>
                                        </select> -->

                    <vue-select label="value" :options="this.journey_managers" :searchable="true"
                      @input="journeyManagerStatus" language="en-US" v-model="trip.journeyManager">
                    </vue-select>
                    <field-messages name="journeyManager" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">
                        Journey Manager is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate auto-label class="form-group" :class="fieldClassName(formstate.remark)">
                    <label>Remarks</label>
                    <textarea name="remark" class="form-control" v-model="trip.remark" placeholder="Remarks"></textarea>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <div v-for="(input, index) in locations" :key="index" class="d-flex">
                    <validate auto-label class="form-group required-field">
                      <label v-if="index === 0">Start Location</label>
                      <label v-else-if="index === locations.length - 1">End Location</label>
                      <label v-else>Halt {{ index }}</label>

                      <select v-model="input.locationId" disabled required class="form-control"
                        @change="handleChange($event, index)">
                        <option selected disabled>Select Location</option>
                        <option v-for="(item, itemIndex) in getFilteredLocationList(
                          index,
                        )" :key="itemIndex" :value="item">
                          {{ item.siteName }}
                        </option>
                        <!-- <option v-for="(item, itemIndex) in locationList" :key="itemIndex"
                                                    :value="item" v-if="(index === 0) && item.siteType === 'MS'">
                                                    {{ item.siteName }}
                                                </option>
                                                <option v-for="(item, itemIndex) in locationList" :key="itemIndex"
                                                    :value="item"
                                                    v-if="(index === locations.length - 1) && item.siteType === 'MS'">
                                                    {{ item.siteName }}
                                                </option>
                                                <option v-for="(item, itemIndex) in locationList" :key="itemIndex"
                                                    :value="item"
                                                    v-if="(index !== 0 && index !== locations.length - 1) && item.siteType !== 'MS'">
                                                    {{ item.siteName }}
                                                </option> -->
                      </select>
                      <field-messages name="regionManager" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">
                          HCV Operation Manager is a required field
                        </div>
                      </field-messages>
                    </validate>
                    <!-- <svg v-if="index === locations.length - 2" @click="addField('locations')"
                                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                            class="ml-2 cursor-pointer svg-icons">
                                            <path fill="none" d="M0 0h24v24H0z" />
                                            <path fill="green"
                                                d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z" />
                                        </svg>
                                        <svg v-if="index > 1 && index < locations.length - 1"
                                            @click="removeField(index, 'locations')" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 24 24" width="24" height="24"
                                            class="ml-2 cursor-pointer svg-icons">
                                            <path fill="none" d="M0 0h24v24H0z" />
                                            <path fill="#EC4899"
                                                d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z" />
                                        </svg> -->
                  </div>
                </div>
              </div>
            </vue-form>
            <div class="col-sm-12 text-right">
              <router-link :to="{ name: 'TripGroup' }">
                <button class="mr-5 btn btn-default" type="button">
                  Cancel
                </button>
              </router-link>
              <section class="content" v-permission.if="[
                USER_ROLES.ADMIN,
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.GA_HEAD,
                USER_ROLES.JOURNEY_MANAGER,
              ]">
                <button class="mr-2 btn gradientbt" @click="updateTripGroupDetails" :disabled="!(formValid)"
                  type="submit">
                  Update Group Trip
                </button>
                <!-- @click="updateTrip" -->
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="gasFlowDia" height="425" :adaptive="false" :click-to-close="false">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
          <!-- <b>{{editGasFlow.title}}</b> -->
          <button type="button" class="close" aria-label="Close" @click="$modal.hide('gasFlowDia')">
            <span aria-hidden="true">&times;</span>
          </button>
        </h4>
      </div>

      <div class="modal-body">
        <table class="table table-bordered">
          <tr style="marginTop:10px">
            <th>Start Location:</th>
            <td>
              <input class="form-control" required v-model="routeData.startLocation" placeholder="Approx. Distance"
                disabled />
              <!-- <datetime type="datetime" v-model="routeData.startLocation" use12-hour></datetime> -->
            </td>
          </tr>
          <tr style="marginTop:10px">
            <th>End Location:</th>
            <td>
              <input class="form-control" required v-model="routeData.endLocation" placeholder="Approx. Distance"
                disabled />
              <!-- <datetime type="datetime" v-model="trip.startDate" use12-hour></datetime> -->
            </td>
          </tr>
          <tr style="marginTop:10px">
            <th>Approx. Time (in Min) :</th>
            <td>
              <input type="number" class="form-control" required v-model="routeData.time"
                placeholder="Approx. Distance" />
            </td>
          </tr>
          <tr style="marginTop:10px">
            <th>Approx. Distance(km) :</th>
            <td>
              <input type="number" class="form-control" required v-model="routeData.distance"
                placeholder="Approx. Distance" />
            </td>
          </tr>
          <tr style="marginTop:10px">
            <th>Region :</th>
            <td>
              <select v-model="routeData.region" required name="region" class="form-control">
                <option value="" disabled>Select G.A</option>
                <option v-for="(item, index) in region_list" :key="index" :value="item.key">
                  {{ item.value }}
                </option>
              </select>
            </td>
          </tr>
        </table>

        <div class="text-right" style="margin-top:20px">
          <button class="btn btn-primary" @click="closeRoute()">Close</button>
          <!-- <button class="btn btn-primary" @click="createRoute()">Save</button> -->
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import {
  formService,
  eventBus,
  tripService,
  tripRouteService,
} from '../../../services';
import { EVENTS } from '../../../config';
import Config, { USER_ROLES } from '../../../config';
import swal from 'sweetalert2';
import { mapState } from 'vuex';
import axios from 'axios';

export default {
  name: 'tripGroupDetail',
  data() {
    return {
      USER_ROLES: USER_ROLES,
      loading: false,
      flash: false,
      flashType: null,
      disabledBefore: new Date(),
      flashMessage: '',
      EVENTS: EVENTS,
      role: {},
      roles: [],
      permissions: [],
      formstate: {},
      region_managers: {},
      vehicle_no: {},
      route_name: {},
      driver_name: {},
      device_name: {},
      journey_managers: {},
      status: 'scheduled',
      sourceSite: '',
      destinationSite: '',
      trip: {},
      locationList: [],
      locations: [
        {
          locationId: '',
        },
        {
          locationId: '',
        },
        {
          locationId: '',
        },
      ],
      list: [],
      routeData: {
        startLocation: '',
        endLocation: '',
        time: '',
        distance: '',
        startLocId: '',
        endLocId: '',
      },
      region_list: {},
      journeyManagerId: [],
      gAId: '',
      regionListFilter: [],
      regionManagerId: '',
      journeyManagerId: [],
      inputValid1: false,
      inputValid2: false,
      inputValid3: false,
      inputValid4: false,
      inputValid5: false,
      inputValid6: false,
      inputValid7: false,
      formValid: false,
    };
  },
  mounted: function () {

    if (this.user.roleName == 'Admin') {
      this.getRegionList();
      this.getLocations();
      this.getRouteName();
    }
    if (this.user.roleName !== 'Admin') {
      this.getDeviceName();

      // if (this.user.roleName != 'Journey Manager') {
      //   this.getJourneyManager();
      // }
      this.getRegionList();
    }
  },

  methods: {
    getFilteredLocationList(index) {
      //0th index selected LNGT then all other must be LNGT
      //otherwise all must be according to condition
      var stations = [];
      if (
        this.locations[0] &&
        this.locations[0].locationId.siteType === 'LNGT'
      ) {
        if (index === 0) {
          stations = this.locationList.filter(
            el => el.siteType === 'MS' || el.siteType === 'LNGT',
          );
        } else {
          stations = this.locationList.filter(el => el.siteType === 'LNGT');
        }
      } else if (
        (index === 0 || index === this.locations.length - 1) &&
        this.locations[0].locationId.siteType !== 'LNGT'
      ) {
        stations = this.locationList.filter(
          el => el.siteType === 'MS' || el.siteType === 'LNGT',
        );
      } else {
        stations = this.locationList.filter(
          el =>
            el.siteType === 'DBS' ||
            el.siteType === 'DCU' ||
            el.siteType === 'DS',
        );
      }

      return stations;
    },
    updateFormValidity() {
      this.formValid = this.inputValid1 && this.inputValid2 && this.inputValid3 && this.inputValid4 && this.inputValid5;


    },
    updateFormFalse() {
      if (this.inputValid1 || this.inputValid2 || this.inputValid3 || this.inputValid4 || this.inputValid5) {
        this.formValid = false;
      }
    },
    flagTrue() {
      this.driverStatus();
      this.HCVOperationStatus();
      this.journeyManagerStatus();
      this.selectedGAFlag();
      this.getDeviceFlag();

    },
    selectedGAFlag() {
      if (this.trip.region !== null && typeof this.trip.region === 'object' && this.trip.region.key !== '') {
        this.inputValid1 = true;
        this.updateFormValidity();
      } else {
        this.inputValid1 = false;
        this.updateFormFalse();
      }

    },
    driverStatus() {
      if (this.trip.driverId.length > 0) {
        this.inputValid3 = true;
        this.updateFormValidity();
      }
      else {
        this.inputValid3 = false;
        this.updateFormFalse();
      }
    },
    HCVOperationStatus() {

      if (this.trip.regionManager !== null && typeof this.trip.regionManager === 'object' && this.trip.regionManager.key !== '') {
        this.inputValid4 = true;
        this.updateFormValidity();
      } else {
        this.inputValid4 = false;
        this.updateFormFalse();
      }
    },
    journeyManagerStatus() {

      if (this.trip.journeyManager !== null && typeof this.trip.journeyManager === 'object' && this.trip.journeyManager.key !== '') {
        this.inputValid5 = true;
        this.updateFormValidity();
      } else {
        this.inputValid5 = false;
        this.updateFormFalse();
      }
    },
    getDeviceFlag() {

      if (this.trip.vehicleId !== null && typeof this.trip.vehicleId === 'object' && this.trip.vehicleId.key !== '') {
        this.inputValid2 = true;
        this.updateFormValidity();
      } else {
        this.inputValid2 = false;
        this.updateFormFalse();
      }
    },

    updateTripGroupDetails() {
      let device_id = this.trip.driverId.map(item => item.key);

      this.loading = true;
      let details = {
        driverId: device_id,
        status: 'scheduled',
        scheduleTime: this.trip.scheduleTime,
        deviceId: this.trip.deviceId,
        journeyManager: this.trip.journeyManager.key,
        regionManager: this.trip.regionManager.key,
        scheduleDate: this.trip.scheduleDate,
        geographical_area: this.trip.geographical_area,
        vehicleId: this.trip.vehicleId.key,
        _id: this.trip._id,
      };
      return tripRouteService
        .updatetripRouteDetails(details)
        .then(response => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success('Trip Group Details update!', 'Success!');
          this.$router.push('/trip-group');
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('trip update failed! Try Again', 'Error!');
          if (error.data.message.includes('must be one of')) {
            this.flash = true;
            this.flashType = 'error';
            this.flashMessage =
              'Update route update is failed.Please try again!';
          }
        });
    },
    selectGA(e) {
      if (this.trip.region !== null && typeof this.trip.region === 'object' && this.trip.region.key !== '') {
        this.inputValid1 = true;
        this.updateFormValidity();
      } else {
        this.inputValid1 = false;
        this.updateFormFalse();
      }
      this.gAId = e.key;
      this.getDriverName();
      this.getRouteName();
      this.getVehicle();
      const filteredRegion = this.regionListFilter.find(
        item => item._id === this.gAId,
      );
      this.regionManagerId = filteredRegion
        ? filteredRegion.regionManager
        : null;
      this.journeyManagerId = filteredRegion
        ? filteredRegion.journeyManager
        : null;
      this.getRegionManager();
      this.getJourneyManager();
      // this.getLocations();
    },

    getAllData(regionId) {
      this.gAId = regionId;
      this.getDriverName();
      this.getRouteName();
      this.getVehicle();
      const filteredRegion = this.regionListFilter.find(
        item => item._id === this.gAId,
      );
      this.regionManagerId = filteredRegion
        ? filteredRegion.regionManager
        : null;
      this.journeyManagerId = filteredRegion
        ? filteredRegion.journeyManager
        : null;
      this.getRegionManager();
      this.getJourneyManager();
      this.getLocations();
      this.setAllData();
      this.getDeviceName();
    },

    setAllData() {
      let driverArray = [];
      this.trip.driverId.forEach(element => {
        let dri = {
          key: element._id,
          value: element.driverName,
        };

        driverArray.push(dri);
      });
      this.trip['driverId'] = driverArray;

      let data = this.trip.subTripDetails;
      let myData = [];
      let requiredList = [];

      data.forEach(function (element, index) {
        if (index === 0) {
          myData.push(element.startSite);
          myData.push(element.endSite);
        } else {
          myData.push(element.endSite);
        }
      });

      myData.forEach(element => {
        let locationData = [];
        let obj = {};
        locationData = this.locationList.filter(el => el._id === element);
        obj['_id'] = locationData[0]._id;
        (obj['siteName'] = locationData[0].siteName),
          (obj['siteType'] = locationData[0].siteType),
          (obj['regionName'] = locationData[0].regionName),
          (obj['region'] = locationData[0].region),
          requiredList.push(obj);
      });
      while (this.locations.length < requiredList.length) {
        this.locations.push({ locationId: '' });
      }
      for (let i = 0; i < requiredList.length; i++) {
        if (requiredList[i] && requiredList[i]._id) {
          this.locations[i].locationId = {
            _id: requiredList[i]._id,
            siteName: requiredList[i].siteName,
            siteType: requiredList[i].siteType,
            regionName: requiredList[i].regionName,
            region: requiredList[i].region,
          };
        } else {
          this.locations[i].locationId = '';
        }
      }

      this.trip['vehicleId'] = {
        key: this.trip.vehicleId._id,
        value: this.trip.vehicleId.regNo,
      };
      this.trip['deviceId'] = this.trip.deviceId._id;

      this.trip['scheduleDate'] = this.trip.scheduleDate;
      this.trip['scheduleTime'] = this.trip.scheduleTime;
      this.trip['regionManager'] = {
        key: this.trip.regionManager._id,
        value:
          this.trip.regionManager.firstName +
          ' ' +
          this.trip.regionManager.lastName,
      };
      this.trip['journeyManager'] = {
        key: this.trip.journeyManager._id,
        value:
          this.trip.journeyManager.firstName +
          ' ' +
          this.trip.journeyManager.lastName,
      };

      const subTripsId = this.trip.subTrips;
      let filteredLocations = this.locationList.filter(location =>
        subTripsId.includes(location._id),
      );
      this.locations['locationId'] = filteredLocations;

      const regionData = this.region_list.filter(
        el => el.key == this.trip.geographical_area,
      );
      this.trip['region'] = {
        key: regionData[0].key,
        value: regionData[0].value,
      };
      this.flagTrue();
    },

    getRegionManagerGetingJM() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      let regionManagerList = [];
      if (this.user.roleName == 'Journey Manager') {
        params.journeyManager = `["${this.user._id}"]`;
        this.isGAHeadDisable = true;
        this.$regionDataRepository.list(params).then(res => {
          if (res.data.docs[0].journeyManager) {
            res.data.docs.forEach(el => {
              this.journeyManagerId = el.journeyManager;
            });
            this.getJourneyManager();
          }
        });
      }
    },

    getRegionList() {
      const params = {};
      this.loading = true;
      params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        params.regionManager = this.user._id;
      }
      if (this.user.roleName === 'Journey Manager') {
        this.isGeographicalAreaDisable = true;
        params.journeyManager = `["${this.user._id}"]`;
      }
      let regionlist = [];
      this.$regionDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          this.regionListFilter = res.data.docs;
          if (res.data.docs) {
            regionlist = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.name,
              };
            });
          }
          this.region_list = regionlist;
          this.getTrip();
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get region list failed', 'Error!');
        });
    },

    getLocations() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.status = 'active';

      if (this.gAId != '') {
        params.region = this.gAId;
      }
      params.$select = ['siteName', 'siteType', '_id', 'regionName', 'region'];
      this.$siteDataRepository
        .list(params)
        .then(res => {
          this.locationList = res.data.docs;
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get route list failed', 'Error!');
        });
    },
    addField(fieldType) {
      this[fieldType].splice(-1, 0, { locationId: null });
    },
    removeField(index, fieldType) {
      this[fieldType].splice(index, 1);
    },

    handleChange(event, index) {
      this.clearIndex = index;
      const locations = this.locations;
      if (index > 0) {
        this.checkRoute(index);
      }
    },

    closeRoute() {
      this.$modal.hide('gasFlowDia');
      this.locations[this.clearIndex].locationId = '';
    },

    /*check if route exists between two locations or not */
    checkRoute(index) {
      const route = this.route_name.find(
        el =>
          this.locations[index - 1].locationId._id === el.startSite &&
          this.locations[index].locationId._id === el.endSite,
      );
      if (route) {
        let val = {
          routeId: route._id,
          startSite: route.startSite,
          endSite: route.endSite,
        };
        this.list.push(val);
      } else {
        this.$modal.show('gasFlowDia');
        this.routeData.startLocation = this.locations[
          index - 1
        ].locationId.siteName;
        this.routeData.endLocation = this.locations[index].locationId.siteName;
        this.routeData.startLocId = this.locations[index - 1].locationId._id;
        this.routeData.endLocId = this.locations[index].locationId._id;
      }
    },

    //  this.$store.dispatch("setBreadcrumbTitle", this.vendor.vdName);

    fieldClassName: formService.fieldClassName,
    getTrip() {
      return this.$tripGroupDataRepository
        .getIndividualGroupTrip(this.$route.params._id)
        .then(response => {
          this.trip = response.data.data[0];
          this.getAllData(this.trip.geographical_area);


        })
        .catch(error => {
          this.$snotify.error('Trip detail failed', 'Error!');
        });
    },
    getSites(e) {
      this.sourceSite = e.target.options[e.target.selectedIndex].getAttribute(
        'sourceSite',
      );
      this.destinationSite = e.target.options[
        e.target.selectedIndex
      ].getAttribute('destinationSite');
    },
    getRegionManager() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.roleRank = 2;
      if (this.gAId !== '') {
        params._id = this.regionManagerId;
      }
      let regionManagerList = [];
      this.$userRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            regionManagerList = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.firstName + ' ' + item.lastName,
              };
            });
          }
          this.region_managers = regionManagerList;
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get region manager list failed', 'Error!');
        });
    },
    getJourneyManager() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.roleRank = 3;
      if (this.gAId !== '') {
        params._id = this.journeyManagerId;
      }

      if (this.user.roleName == 'Journey Manager') {
        let bAsString = this.journeyManagerId.map(value => String(value));
        let jsonString = JSON.stringify(bAsString);
        params._id = jsonString;
      }

      let journeyManagerList = [];
      this.$userRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            journeyManagerList = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.firstName + ' ' + item.lastName,
              };
            });
          }
          this.journey_managers = journeyManagerList;
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get journey manager list failed', 'Error!');
        });
    },
    getVehicle() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      if (this.gAId !== '') {
        params.region = this.gAId;
      }
      let vehicleList = [];
      this.$vehicleDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            vehicleList = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.regNo,
              };
            });
          }
          this.vehicle_no = vehicleList;
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get vehicle list failed', 'Error!');
        });
    },
    getDriverName() {
      this.loading = true;
      const params = {};
      if (this.gAId !== '') {
        params.region = this.gAId;
      }
      params.$limit = 0;
      let driverList = [];
      if (this.user.roleName == 'Journey Manager') {
        params.regionJourneyManager = `["${this.user._id}"]`;
      }
      // if (this.regionManagersIdList.length !== 0) {
      //   params.regionRegionManager = this.regionManagersIdList;
      // }

      this.$driverDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            this.driver_name = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.driverName,
              };
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get driver list failed', 'Error!');
        });

      // }
    },
    getDeviceName() {

      if (this.trip.vehicleId !== null && typeof this.trip.vehicleId === 'object' && this.trip.vehicleId.key !== '') {
        this.inputValid2 = true;
        this.updateFormValidity();
      } else {
        this.inputValid2 = false;
        this.updateFormFalse();
      }

      this.loading = true;
      const params = {};
      params.$limit = 0;

      // if (this.trip.vehicleId.key) {
      //     params._id = this.trip.vehicleId.key

      // }
      //params.roleRank = 4;
      console.log('qqqqqqqqqqqqqqqqqqqqqqqqqqqqqq')
      let deviceList = [];
      this.$deviceDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            deviceList = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.deviceId,
              };
            });
          }
          this.device_name = deviceList;
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get device list failed', 'Error!');
        });
    },
    getRouteName() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      if (this.gAId !== '') {
        params.region = this.gAId;
      }
      let routeList = [];
      this.$triprouteDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            routeList = res.data.docs;
          }
          this.route_name = routeList;
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get route list failed', 'Error!');
        });
    },
    updateTrip() {
      this.loading = true;
      let device_id = this.trip.driverId.map(item => item.key);
      let trip = {
        driverId: device_id,
        status: this.status,
        scheduleTime: this.scheduledTime,
        deviceId: this.selectedDeviceId,
        journeyManager: this.trip.journeyManager.key,
        regionManager: this.trip.regionManager.key,
        scheduleDate: this.trip.scheduleDate,
        vehicleId: this.trip.vehicleId.key,
        subTrips: this.list,
        remark: this.trip.remark,
        _id: this.trip._id,
      };

      return tripService
        .updateTrip(trip)
        .then(response => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success('Trip details updated!', 'Success!');
          this.$router.push('/trip-group');
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Add Trip failed', 'Error!');
          if (error.data.message.includes('must be one of')) {
            this.flash = true;
            this.flashType = 'error';
            this.flashMessage =
              'Trip is not updated due to some error. Please try again!.';
          }
        });
    },
    deleteTripModal() {
      swal({
        title: 'Are you sure?',
        text: 'This will permanently delete this Trip!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(result => {
        if (result.value) {
          this.deleteTrip();
        }
      });
    },
    deleteTrip() {
      this.loading = true;
      return tripService
        .tripGroupDelete(this.trip._id)
        .then(response => {
          this.loading = false;
          return swal('Deleted!', 'Trip has been deleted.', 'success');
        })
        .then(response => {
          this.loading = false;
          this.$router.push('/trip-group');
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Delete trip failed', 'Error!');
        });
    },
    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  created() {
    const promises = [];
    this.loading = true;
    // promises.push(this.getTrip())
    promises.push(this.getLocations());

    Promise.all(promises)
      .then(() => {
        this.loading = false;
        this.ready = true;
      })
      .catch(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
/* .required-field>label::after,
label::after {
    content: '*';
    color: red;
    margin-left: 0.25rem;
} */

.required-field>label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}

.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}

.has-danger {
  color: red;
}

.swal2-popup {
  font-size: 2rem !important;
}

.gradientbt {
  background-image: linear-gradient(to right,
      rgba(38, 153, 251),
      rgba(146, 205, 255));
  color: white;
}
</style>



// WEBPACK FOOTER //
// TripGroupDetail.vue?7a8bddae